import React from 'react'

function index() {
    return (
        <div>
            <h1>about</h1>
        </div>
    )
}

export default index
